import { useContext, useState } from "react";
import "./AnotherSearchLocation.css";
import { IoMdLocate } from "react-icons/io";
import { FaLocationArrow } from "react-icons/fa";
import { FiEdit3 } from "react-icons/fi"; // Icon for typing indication
import { useDispatch } from "react-redux";
import AddressAutocomplete from "./Map/AddressAutocomplete";
import { fetchLocation } from "../../Redux/State-slice/Location";
import { LanguageContext } from "../../Context/LanguageContext";
import labels from "../../translationData/menu.json";
import getTranslation from "../../Helper/getTranslationUtility";

/**
 * The compact address bar shown in the header before a location is known.
 * Backed by Mapbox geocoding, so a chosen suggestion already carries its
 * coordinates and nothing has to be looked up a second time.
 */
const AnotherSearchLocation = ({ setUserAddress, handleSelect }) => {
  const [typeAddress, setTypeAddress] = useState("");
  const [selectedPlace, setSelectedPlace] = useState(null);
  const { currentLanguage } = useContext(LanguageContext);
  const dispatch = useDispatch();

  const isUserTyping = !!typeAddress && !selectedPlace;

  const handleChange = (value) => {
    setTypeAddress(value);
    // Typing again invalidates the previous pick.
    setSelectedPlace(null);
  };

  const handleSubmit = () => {
    if (!selectedPlace) return;
    setUserAddress(selectedPlace.address);
    handleSelect(selectedPlace);
    setSelectedPlace(null);
  };

  const handleLocateMe = () => dispatch(fetchLocation());

  return (
    <div className="ALb-component">
      <div className="row g-0 gap-0 ALb-inner">
        {/* Search Box */}
        <div className="col-9 d-flex align-items-center">
          <AddressAutocomplete
            value={typeAddress}
            onChange={handleChange}
            onSelect={(place) => {
              setTypeAddress(place.address);
              setSelectedPlace(place);
            }}
            placeholder="Search Places ..."
            className="w-100 p-2 border-0 location-search-input"
          />
        </div>

        {/* Button Section */}
        <div className="col-3 btn-component d-flex justify-content-center align-items-center">
          {isUserTyping ? (
            <div className="d-flex align-items-center text-white">
              <FiEdit3 /> {/* Typing indicator icon */}
            </div>
          ) : selectedPlace ? (
            <div className="d-flex align-items-center text-white">
              <FaLocationArrow />
              <button className="submit-btn text-white" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          ) : (
            <div
              className="d-flex justify-center align-items-center justify-content-center locate-btn"
              onClick={handleLocateMe}
            >
              <IoMdLocate />
              <span className="mx-1 locate-text">
                {getTranslation("locateMe", currentLanguage, labels)}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnotherSearchLocation;
